import styled, { css } from "styled-components";

export const Container = styled.div`
    padding: 2.5rem 2rem;
    max-width: 30rem;
    width: 100%;
    background: #F0F1F5;
    margin: 0.5rem;
    border-radius: 5px;
    border: 5px solid ${props => props.border ? props.border : 'transparent'};
    font-weight: 900;
    color: #535354;
    position: relative;

    display: grid;
    grid-template-columns: repeat(2, 1fr);

    .management {
        position: absolute;
        top: 10px;
        right: 10px;

        display: flex;
        align-items: center;

        svg{
            font-size: 1.3rem;
            margin: 0 0.2rem;    
            
            &:first-child{
                font-size: 1.2rem;
            }
            &:hover{
                cursor: pointer;
            }
        }
    }
     
    @media (max-width: 1100px) {
        max-width: 25rem;
    } 

    @media (max-width: 875px) {
        padding: 2.5rem 1rem;
        max-width: 30rem;
        margin: 0.5rem auto;
    }
`   

export const Title = styled.div`
    font-size: 1.2rem;
    text-transform: uppercase;
    letter-spacing: 1px; 
    
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 480px) {
        font-size: 1rem;
        letter-spacing: 0;

        p{
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 10rem;
            text-align: center;
            display: block;
            overflow: hidden
        }
    }
`

export const Info = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-left: 0.5rem;

    div{
        font-size: 0.8rem;

        display: flex;
        align-items: center;
        justify-content: flex-start;

        & + div {
            margin-top: 0.5rem;
        }

        svg{
            margin-right: 0.5rem;
            font-size: 1rem;
        }
    }
`

export const Slider = styled.div`
    height: 1rem;
    width: 2rem;
    background: ${props => props.switchButtonActive ? 'green' : '#535354'};
    border-radius: 10px;
    margin-left: 0.5rem;
    transition: background 0.3s ease;

    display: flex;
    align-items: center;

    .circle{
        height: 0.75rem;
        width: 0.75rem;
        background: #FFF;
        border-radius: 50%;
        transition: transform 0.3s ease;
        transform: translateX(20%);
    }

    &:hover{
        cursor: pointer;
    }

    ${props => props.switchButtonActive && css`
        .circle{
            transform: translateX(150%);
        }
    `}
`